export default "__VITE_ASSET__Dh6e9B57__"